export const SERVER_URL = "https://do-calculate.com/api";

export const AgeGregorian_EndPoint = "calculate-age-gregorian";
export const AgeHijri_EndPoint = "calculate-age-hijri";
export const DateGregorianDifferences_EndPoint =
  "calculate-date-gregorian-differences";
export const DateHijriDifferences_EndPoint = "calculate-date-hijri-differences";
export const humanCalculators = [
  {
    name: "Kalkulator Usia",
    link: "/calculator/id/agegregorian/",
    description:
      "Kalkulator ini menghitung usia dalam tahun, bulan, dan hari menggunakan kalender Masehi dan Hijriah",
    showMain: true
  },
  {
    name: "Kalkulator Usia Hijriah",
    link: "/calculator/id/agehijri/",
    description:
      "Perhitungan usia hijriah, kalkulator usia hijriah, konversi tanggal ke usia hijriah, kalkulator usia hijriah, usia hijriah, konversi tanggal ke tahun hijriah, perhitungan usia dalam tanggal hijriah, kalkulator usia profesional hijriah, perhitungan usia akurat dengan hijriah, hijrah ke usia aktual, perhitungan usia seseorang dalam tanggal hijriah, perhitungan usia menurut kalender hijriah",
    showMain: true
  },
  {
    name: "Kalkulator Perbedaan Antara Dua Usia",
    link: "/calculator/id/gregoriandifferences/",
    description:
      "Kalkulator ini menghitung perbedaan antara dua usia tertentu menggunakan kalender Masehi.",
    showMain: true
  },
  {
    name: "Kalkulator Perbedaan Antara Dua Tanggal atau Usia",
    link: "/calculator/id/dategregoriandifferences/",
    description:
      "Kalkulator ini digunakan untuk menghitung perbedaan antara dua tanggal tertentu menggunakan kalender Masehi.",
    showMain: true
  },
  {
    name: "Kalkulator Perbedaan Antara Dua Tanggal dalam Hijriah",
    link: "/calculator/id/datehijridifferences/",
    description:
      "Kalkulator ini menghitung perbedaan antara dua tanggal tertentu menggunakan kalender Hijriah.",
  },
  {
    name: "Hitung Berapa Lama Lagi hingga Ulang Tahun Saya",
    link: "/calculator/id/birthday/",
    description:
      "Gunakan kalkulator ini untuk mengetahui sisa waktu hingga ulang tahun Anda secara detail menurut kalender Masehi. Masukkan tanggal ulang tahun untuk mendapatkan perbedaan antara waktu saat ini dan ulang tahun Anda dalam bulan dan hari.",
    showMain: true
  },
  {
    name: "Konversi Tanggal dari Masehi ke Hijriah",
    link: "/calculator/id/gregorian_to_hijri/",
    description:
      "Konversi tanggal dari Masehi ke Hijriah dengan memasukkan tanggal dalam Masehi dan mengetahui padanannya dalam Hijriah menggunakan konverter tanggal elektronik",
    showMain: true
  },
  {
    name: "Konversi Tanggal dari Hijriah ke Masehi",
    link: "/calculator/id/hijri_to_gregorian/",
    description:
      "Konversi tanggal dari Hijriah ke Masehi dengan memasukkan tanggal dalam Hijriah dan mengetahui padanannya dalam tanggal Masehi menggunakan konverter tanggal elektronik",
  },
  {
    name: "Kalkulator Usia: Hijriah atau Masehi",
    link: "/calculator/id/age/",
    description:
      "Program perhitungan usia dalam Hijriah dan Masehi, layanan kalkulator usia dalam bulan, hari, jam, menit, dan detik secara detail dalam berbagai bentuk dan format dengan sangat akurat dan fakta kesehatan tentang usia Anda",
  },
  {
    name: "Kalkulator Waktu dan Durasi",
    link: "/calculator/id/time-calculator/",
    description:
      "Kalkulator waktu dan durasi gratis membantu Anda menambah atau mengurangi nilai waktu dalam hari, jam, menit, atau detik dengan mudah dan Anda juga dapat mempelajari konsep waktu yang berbeda.",
    showMain: true
  },
  {
    name: "Jumlah Hari - Hitung Jumlah Hari",
    link: "/calculator/id/days-calculator/",
    description:
      "Kalkulator ini menghitung perbedaan antara dua tanggal dalam berbagai satuan seperti hari, bulan, tahun, menit, detik, jam, dan minggu.",
  },
  {
    name: "Kalkulator Usia Berdasarkan Tahun Kelahiran",
    link: "/calculator/id/gregorian/gregorian-year-list/",
    description:
      "Kalkulator ini menghitung usia dalam tahun, bulan, dan hari menggunakan kalender Masehi, dengan kemampuan memasukkan tahun kelahiran saja.",
  },
  {
    name: "Hari Ini Masehi dan Hijriah",
    link: "/calculator/id/current-date/",
    description:
      "Tanggal hari ini Masehi dan Hijriah - mengetahui tanggal saat ini, menampilkan tanggal saat ini dalam kalender Masehi dan Hijriah dengan detail hari dan jam. Mengetahui tanggal hari ini secara akurat menurut kalender Masehi dan Hijriah.",
  },
  {
    name: "Hari Ini Masehi dan Hijriah",
    link: "/calculator/id/current-date/",
    description:
      "Tanggal hari ini Masehi dan Hijriah - mengetahui tanggal saat ini, menampilkan tanggal saat ini dalam kalender Masehi dan Hijriah dengan detail hari dan jam. Mengetahui tanggal hari ini secara akurat menurut kalender Masehi dan Hijriah.",
  }, {
    name: "Kalkulator Durasi Sejak Kematian",
    link: "/calculator/id/duration-since-death/",
    description:
      "Kalkulator durasi sejak kematian - menghitung durasi sejak kematian dalam kalender Masehi dan Hijriah. Masukkan tanggal kematian untuk mengetahui durasi yang telah berlalu sejak tanggal tersebut.",
  },
  {
    name: "Kalkulator Ulang Tahun Pernikahan Tahunan",
    link: "/calculator/id/wedding-anniversary-calculator/",
    description:
      "Kalkulator ulang tahun pernikahan tahunan - menghitung jumlah tahun, bulan, dan hari sejak tanggal pernikahan. Masukkan tanggal pernikahan Anda untuk mengetahui durasi yang telah berlalu sejak tanggal tersebut.",
  },
];
export default humanCalculators;